import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * Bannière « fin de période d'essai ».
 * Affichée lorsque l'utilisateur est en cours d'essai pro et qu'il lui
 * reste 15 jours ou moins avant la fin de la période.
 */
const TrialBanner = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const [daysLeft, setDaysLeft] = useState(null);

  useEffect(() => {
    if (!user?.loggedIn) {
      setDaysLeft(null);
      return;
    }
    const onTrial =
      user?.trialUserForPlan &&
      user?.planId &&
      String(user.planId) === String(user.trialUserForPlan);
    const expiry = user?.trialExpiryDate;
    if (!onTrial || !expiry) {
      setDaysLeft(null);
      return;
    }
    const days = Math.ceil(
      (new Date(expiry).getTime() - Date.now()) / (24 * 60 * 60 * 1000)
    );
    setDaysLeft(days > 0 ? days : 0);
  }, [user]);

  if (daysLeft == null || daysLeft <= 0 || daysLeft > 15) return null;

  return (
    <div className="trial-banner">
      <span className="trial-banner-text">
        {t("trialBanner.remaining", {
          defaultValue: `Il vous reste {{count}} jour${daysLeft > 1 ? "s" : ""} d'essai gratuit.`,
          count: daysLeft,
        })}
      </span>
      <Link to="/pro-offers" className="trial-banner-btn">
        {t("trialBanner.upgrade", { defaultValue: "Passer Pro" })}
      </Link>
    </div>
  );
};

export default TrialBanner;